import React, { Component } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import Swal from "sweetalert2";
import { Modal, ModalBody } from "reactstrap";

class CardNumberDetail extends Component {
  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.cardDetail}
          toggle={() => this.props.changeModal(!this.props.cardDetail)}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-0 fs-6 fw-bold mb-3">شماره کارت</div>
            <div className="col-12 px-0 text-center">
              <CopyToClipboard
                text={this.props.card.number.split(" ").join("")}
                onCopy={() =>
                  Swal.fire({
                    icon: "success",
                    text: "کپی شد",
                    timer: 2000,
                    showConfirmButton: false,
                  })
                }
              >
                <p className="color-second fs-4 fw-bold mb-0" dir="ltr">
                  {this.props.card.number}
                </p>
              </CopyToClipboard>
            </div>
            <div className="row mx-0 my-2 justify-content-around">
              <span className="col-auto fw-bolder align-self-center">
                {this.props.card.name}
              </span>
              {this.props.card.icon && (
                <img
                  className="col-2 px-0"
                  src={this.props.card.icon.icon_128}
                  alt="icon_bank"
                />
              )}
            </div>
            <div className="row mx-0 mt-3">
              <div className="col-12 px-0 text-center">
                <CopyToClipboard
                  text={this.props.card.number.split(" ").join("")}
                  onCopy={() =>
                    Swal.fire({
                      icon: "success",
                      text: "کپی شد",
                      timer: 2000,
                      showConfirmButton: false,
                    })
                  }
                >
                  <button className="btn border px-4 py-2 small rounded28 color-main fw-bold">
                    کپی
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default CardNumberDetail;
